import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Handshake, Plus } from "lucide-react";
import { api } from "@/app/api";

const STATUS_STYLE = {
  draft: "bg-slate-100 text-slate-600",
  review: "bg-amber-50 text-amber-700",
  approved: "bg-sky-50 text-sky-700",
  published: "bg-emerald-50 text-emerald-700",
};

export default function Partners() {
  const [partners, setPartners] = useState(null);

  useEffect(() => {
    api.get("/admin/partners").then((response) => setPartners(response.data.partners)).catch(() => setPartners([]));
  }, []);

  return (
    <div data-testid="admin-partners" className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold text-ink">Partners</h1>
          <p className="mt-1 text-sm text-slatey">Configure recruitment partners, their providers, programmes, submission methods and commission rules — no developer needed.</p>
        </div>
        <Link to="/app/admin/partners/new" data-testid="add-partner-button" className="inline-flex items-center gap-2 rounded-full bg-cobalt px-5 py-3 text-sm font-bold text-white"><Plus className="h-4 w-4" /> Add partner</Link>
      </div>

      {!partners ? <p className="text-sm text-slatey">Loading…</p> : (
        <div className="grid gap-4">
          {partners.map((partner) => (
            <Link key={partner.id} to={`/app/admin/partners/${partner.id}`} data-testid={`partner-card-${partner.id}`}
              className="flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-slate-200 bg-white p-5 transition-colors hover:border-cobalt/40">
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cobalt/10 text-cobalt"><Handshake className="h-5 w-5" /></div>
                <div>
                  <p className="font-display text-lg font-bold text-ink">{partner.name}</p>
                  <p className="text-xs text-slatey">{partner.partner_type.replaceAll("_", " ")} · {partner.provider_count} providers · {partner.programme_count} programmes · {partner.opportunity_count} opportunities · submission: {partner.submission_method?.type}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs font-bold text-slatey">v{partner.config?.version}</span>
                <span className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${STATUS_STYLE[partner.config?.status] || STATUS_STYLE.draft}`} data-testid={`partner-status-${partner.id}`}>{partner.config?.status}</span>
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${partner.active ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{partner.active ? "Active" : "Inactive"}</span>
              </div>
            </Link>
          ))}
          {partners.length === 0 && <p className="rounded-3xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slatey">No partners yet. Add the first one.</p>}
        </div>
      )}
    </div>
  );
}
